import React from "react";
import piramisLogo from '../assets/logo-piramis.png';
import packageJson from '../../../package.json';

const Footer = () => {
  const year = new Date().getFullYear();
  const copyText = `Piramis Locator CRM Versione ${packageJson.version} -  \u00A9 ${year} by `;
  return (
    <footer id="footer" className="bg-light text-center pt-2 app-footer app-footer--shadow">
      <div>
        <img src={piramisLogo} style={{ height: 21, width: "auto" }} /> {copyText}
        <a href="https://www.piramislocator.com" target="_blank">Piramis Locator</a>
      </div>
    </footer >
  );
};

export default Footer;
